export default "<div ui-grid=\"$ctrl.gridOptions\"></div>";